import { ClearDiv, DynamicTextEditor } from '@aon/aon-tws-common-ui';
import { TranslationEditorContainer } from '../../../containers/translations/TranslationEditorContainer';
import React from 'react';
import { useDispatch } from 'react-redux';
import ContentConstants from '../../../contentConstants';
import { ITranslationEditItem } from '../../../models';
import { ActionCreators, InitDefaultTranslationEditItem } from '../../../store/SurveyStore';
import { Col3Col9 } from '../../common';
import Constants from '../../../constants';
import { ISurveyTermEditModel } from '../../../models/ISurveyTermEditModel';
import { ActionTypes } from '../../../store/ActionTypes';
import { useSurveyDefaultCultureCode } from '../../../utilities/hooks';

export interface ISurveyDefinitionPageDescriptionProps {
	supportedCultures: string[];
	surveyId: number;
	surveyTerm: ISurveyTermEditModel;
	readOnly: boolean;
	saveInModal?: boolean;
}

export function SurveyDefinitionPageDescription(props: ISurveyDefinitionPageDescriptionProps) {
	const dispatch = useDispatch();
	const defaultCultureCode = useSurveyDefaultCultureCode();
	const { supportedCultures, surveyId, surveyTerm, readOnly, saveInModal } = props;

	function HandlePageDescriptionChange(value: string) {
		dispatch(ActionCreators.HandleSurveyTermPageDescriptionChange(value));
	}
	function HandleTranslationEditorPageDescriptionUpdate(item: ITranslationEditItem) {
		if (saveInModal) {
			dispatch(ActionCreators.HandleTranslationEditorPageDescriptionUpdate(item));
		} else {
			// When updating in translationEditorStor we still need to set surveyEditModel.isSurveyTermUpdated to true
			dispatch({ type: ActionTypes.SURVEY_TERM_TRANSLATION_UPDATED });
		}
	}

	return (
		<>
			<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_SURVEY_DEFINITIONS_PAGE_DESCRIPTION}>
				<ClearDiv clearHeight={'15px'} />
				<DynamicTextEditor
					id='term-page-description-editor'
					inputType='textarea'
					enableHtmlEditor={true}
					htmlEditorMode={'custom'}
					toolbarConfiguration={Constants.customHtmlEditorOptions}
					placeholder={ContentConstants.SUBSECTIONHEADERS_SURVEY_DEFINITIONS_PAGE_DESCRIPTION}
					onChange={HandlePageDescriptionChange}
					value={surveyTerm.pageDescription?.textValue}
					readOnly={readOnly}
				/>
				<ClearDiv clearHeight={'15px'} />
				{surveyId !== 0 && (
					<TranslationEditorContainer
						enableHtmlEditor={!readOnly}
						property={'survey-term/page-description'}
						inputType={'textarea'}
						propertyDisplayName={ContentConstants.SUBSECTIONHEADERS_SURVEY_DEFINITIONS_PAGE_DESCRIPTION}
						supportedCultures={supportedCultures}
						uniqueId={surveyTerm?.surveyTermId}
						surveyId={surveyId}
						defaultTranslation={surveyTerm?.pageDescription ?? InitDefaultTranslationEditItem(defaultCultureCode)}
						notifyUpdate={HandleTranslationEditorPageDescriptionUpdate}
						disabled={readOnly}
						saveInModal={saveInModal}
					/>
				)}
			</Col3Col9>
		</>
	);
}
